import React from 'react';

function BMDForm() {
  return (
    <div>
      <h2>BMDForm</h2>
    </div>
  );
}

export default BMDForm;
